export default __webpack_public_path__ + "static/media/noStudents.0634926c.svg";